import { Component, OnInit } from '@angular/core';
import { BrandEnum } from 'src/app/core/dtos/enum';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';

@Component({
  selector: 'app-feature-list',
  templateUrl: './feature-list.component.html',
  styleUrls: ['./feature-list.component.scss']
})
export class FeatureListComponent implements OnInit {

  brandId: BrandEnum;
  launchSRDownload: boolean;
  brandName: string;

  constructor(private configHelper: ConfigHelper) { }

  public get BrandEnum() {
    return BrandEnum;
  }

  ngOnInit(): void {
    this.brandId = this.configHelper.getBrandId();
    this.brandName = this.configHelper.getBrandName();
    this.launchSRDownload = this.configHelper.getLaunchSRDownload() === 1;
  }

}
